/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RequestUpdateSystemAdminRole400ResponseErrors
 */
export interface RequestUpdateSystemAdminRole400ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateSystemAdminRole400ResponseErrors
     */
    'reason': RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum;
}

export const RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum = {
    specifiedRole: 'NOT_SPECIFIED_ROLE',
    foundUser: 'NOT_FOUND_USER',
    foundRole: 'NOT_FOUND_ROLE',
    coveredOrganization: 'NOT_COVERED_ORGANIZATION'
} as const;

export type RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum = typeof RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum[keyof typeof RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum];


